import React from 'react';


const Emoticon = ({ attach }) => {

  return (
    <div className="cont">
      <div className="txt">
        <div className="data"><img src={`${process.env.REACT_APP_FILE_API_URL}?type=10&serverfile=${attach.goodsid}/${attach.code}.${attach.type === 'gif' ? 'gif' : 'png'}&device=web`} alt={`이모티콘:${attach.goodsid}/${attach.code}`} data-emoji={`이모티콘:${attach.goodsid}/${attach.code}`}/></div>
      </div>
    </div>
  )
}

export default React.memo(Emoticon);